<cm-video-viewer
  [video]="message.videos[0]"
  (closeVideoViewer)="onCloseVideoViewer($event)"
></cm-video-viewer>
